import { render, staticRenderFns } from "./NotifyAttendeeModal.vue?vue&type=template&id=6f0caa79&scoped=true"
import script from "./NotifyAttendeeModal.vue?vue&type=script&lang=js"
export * from "./NotifyAttendeeModal.vue?vue&type=script&lang=js"
import style0 from "./NotifyAttendeeModal.vue?vue&type=style&index=0&id=6f0caa79&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f0caa79",
  null
  
)

export default component.exports